angular.module("ainapp")
    .controller("AccountTypeController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Account Type";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Init = function () {

                $scope.load = true;
                $scope.Accounts = [];

                MainService.AccountTypesInDropdown().then(function (response) {
                    $scope.Accounts = response.data;
                    $scope.load = false;
                }, function (err) {
                    $scope.load = false;
                });

            }
            $scope.Init();


            $scope.KendoSource = new kendo.data.DataSource({
                //batch: true,
                transport: {
                    read: function (o) {
                        MainService.AccountTypesInDropdown(o.data).then(function (response) {
                            var temp = {
                                Data: response.data
                            }
                            o.success(temp);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("Network Error");
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Code: {
                                type: "string",
                                editable: false,
                            },
                            Name: {
                                type: "string",
                                editable: false,
                            },

                        }
                    }
                },
                //                serverPaging: true,
                //                serverSorting: true,
                //                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: false,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },

                columns: [
                    {
                        field: "Code",
                        title: "Code",
                        },
                    {
                        field: "Name",
                        title: "Name",
                        },
                    ],
            };



        }])
